<template><div><h1 id="faktura-zurucksetzen" tabindex="-1"><a class="header-anchor" href="#faktura-zurucksetzen"><span>Faktura zurücksetzen</span></a></h1>
<p>Faktura zurücksetzen — Stornieren von Fakturen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Funktion storniert Fakturen. Zu einem einzelnen Auftrg können mehrere Fakturen bestehen (z.B. bei Teillieferungen). Deshalb muss muss beim zurücksetzen von Aufträgen geprüft werden, ob mehere Fakturen storniert werden sollen.</p>
<p>Alle Artikel der Faktura werden zurückgebucht (Ausnahme: Sammelfakturen, wo keine Buchungen zurückgesetzt werden). Die betreffenden Auftragspositionen werden wieder auf 'reserviert' gesetzt und sind wieder mutierbar.</p>
<p>Der betreffende Auftrag ist wieder pendent (bzw. teilweise pendent, wenn bereits teilweise fakturiert) und kann bei Bedarf gelöscht werden. Beim nächsten Aufbereitungslauf wird ein neuer WBS gedruckt.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Aufträge → Verarbeitungsläufe → Fakturen/Avis verarbeiten → Faktura zurücksetzen</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Folgende Faktura zurücksetzen</dt>
<dd>Fakturanummer</dd>
<dt>Auftragsnummer</dt>
<dd>wird automatisch ausgefüllt.</dd>
<dt>Auftraggeber</dt>
<dd>Personen-ID und Adresse des Auftraggebers</dd>
<dt>Sind Sie sicher?</dt>
<dd>Sicherheitsabrage. Muss auf &quot;ja&quot; gesetzt werden, damit die Stornierung ausgelöst wird.</dd>
<dt>Ausgabe</dt>
<dd>Keine Ausgabe</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Es gibt keinen Output</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Zur Fakturanummer zugehörige Buchungen (Lager, OP, EB), der zur Fakturanummer gehörende Auftrag.</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Das Programm macht sowohl Lager- wie auch Finanzbuchungen. Weiter werden die betroffenen Auftragspositionen wieder auf den Status reserviert gesetzt.</p>
<p>Die Artikel der stornierten Auftragspositionen werden wieder zurück an Lager (zum Jobdatum) gebucht.</p>
<p>Die Auftragsbuchung (Typ A) wird zum Jobdatum storniert.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


